module.exports = __webpack_public_path__ + "img/ayw-01.180bb6fa.png";